/* eslint-disable import/first */
// Synchronous Self-Healing Recovery: Break any authentication loops before React mounts
(function() {
  if (typeof window !== 'undefined' && window.location) {
    const searchParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const hasError = searchParams.get('error') === 'server_error' || hashParams.get('error') === 'server_error';
    
    if (hasError) {
      console.warn('⚠️ Server auth error detected. Wiping invalid tokens to prevent loop...');
      
      if (window.localStorage) {
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('sb-') && key.endsWith('-auth-token')) {
            localStorage.removeItem(key);
          }
        });
        localStorage.removeItem('sb-test-auth-token');
        localStorage.removeItem('sb-stable-auth-token');
        localStorage.removeItem('leaf_env_mode'); // Reset to default stable mode
      }
      
      // Clean URL params
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
      
      // Force quick reload
      window.location.reload();
    }
  }
})();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
